module.exports = __webpack_public_path__ + "img/4-4.2635297d.png";